import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase';

// Built-in fallback, used until the admin seeds the editable `expenseCategories`
// collection (Admin Settings → Expense Categories) or if it is emptied.
export const DEFAULT_EXPENSE_CATEGORIES = [
  'Accommodation',
  'Flights',
  'Ground Transport',
  'Match Tickets',
  'Stadium Tour',
  'Training Facilities',
  'Meals & Catering',
  'Marketing',
  'Staff Costs',
  'Professional Services',
  'Software & Subscriptions',
  'Other',
];

// Live list of active expense category names, ordered by `order`.
export function useExpenseCategories() {
  const [categories, setCategories] = useState(DEFAULT_EXPENSE_CATEGORIES);

  useEffect(() => {
    const q = query(collection(db, 'expenseCategories'), orderBy('order', 'asc'));
    return onSnapshot(q, (snap) => {
      const names = snap.docs
        .map((d) => d.data())
        .filter((c) => c.active !== false)
        .map((c) => c.name);
      if (names.length) setCategories(names);
    }, () => {}); // permission/network error → keep the defaults
  }, []);

  return categories;
}
